import { useTranslation } from '../../i18n';
import { Badge } from '../ui/badge';
import { AdminBot } from '../../types/bots';

type EWebhookState = 'none' | 'healthy' | 'failing' | 'autoDisabled';

interface IBotWebhookBadgeProps {
  bot: Pick<AdminBot, 'webhookUrl' | 'webhookDisabledAt' | 'webhookFailStreak'>;
}

const resolveState = (bot: IBotWebhookBadgeProps['bot']): EWebhookState => {
  if (bot.webhookDisabledAt) return 'autoDisabled';
  if (!bot.webhookUrl) return 'none';
  if (bot.webhookFailStreak > 0) return 'failing';
  return 'healthy';
};

/** Tiny, pure webhook-health badge — reused by the list and detail screens. */
const BotWebhookBadge = ({ bot }: IBotWebhookBadgeProps) => {
  const { t } = useTranslation();
  const state = resolveState(bot);

  const VARIANT_BY_STATE = {
    none: 'muted',
    healthy: 'success',
    failing: 'warning',
    autoDisabled: 'danger',
  } as const;

  const LABEL_KEY_BY_STATE = {
    none: 'bots.webhook.polling',
    healthy: 'bots.webhook.healthy',
    failing: 'bots.webhook.failing',
    autoDisabled: 'bots.webhook.autoDisabled',
  } as const;

  return (
    <Badge variant={VARIANT_BY_STATE[state]}>
      {t(LABEL_KEY_BY_STATE[state])}
    </Badge>
  );
};

export default BotWebhookBadge;
